export enum CommonFieldTypes {
  STRING = "String",
  BOOLEAN = "Boolean",
  HOSTNAME = "Hostname",
  INT = "Int",
}

export const EndIDFieldType: string = "ID";
export const EndIdFieldName: string = "Id";
